import React from 'react';
import LeaveCalendar from '../components/LeaveCalendar/LeaveCalendar';

const LeaveCalendarPage: React.FC = () => {
  // You can get employeeId from route or context if needed
  return <LeaveCalendar />;
};

export default LeaveCalendarPage;
